function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M77.9 112.2l-20-20.1-29.6 29.5V92.1H0v77.8h77.8v-28.4H48.5zM92.2 57.7l20 20.1 29.5-29.6v29.6h28.4V0H92.3v28.3h29.2zM78 283.5H0V255h49.5v-42.6h49.6v-42.6h49.6v-42.5h49.6V84.8h49.6V42.4h28.5v70.9h-49.6v42.5h-49.6v42.5h-49.6v42.6H78z"
})));